import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ootImg } from "../imgUrl";

function Item({ data }) {
  const [wish, setWish] = useState(false);
  const [broken, setBroken] = useState(false);
  const navigate = useNavigate();
  const open = () => navigate(`/Product/${data.id}`);

  // Cards render ~250px wide; ask the CDN for 500 (2x for retina) instead of the
  // full-size original.
  const src = ootImg(data.default_image, 500);

  const price = Number(data.price || 0);
  const was = Number(data.price_before_discount || 0);
  const hasDiscount = was > price;
  const off = hasDiscount ? Math.round(((was - price) / was) * 100) : 0;

  return (
    <div className="oot-card" onClick={open}>
      <div className="oot-card-imgwrap">
        {hasDiscount && <span className="oot-badge">-{off}%</span>}
        <button className={`oot-wish${wish ? " on" : ""}`} title="Add to wishlist"
          onClick={(e) => { e.stopPropagation(); setWish(!wish); }}>
          <svg viewBox="0 0 24 24" fill={wish ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l1.1 1L12 21l7.7-7.6 1.1-1a5.5 5.5 0 0 0 0-7.8z" />
          </svg>
        </button>
        {src && !broken ? (
          <img src={src} alt={data.name} loading="lazy" onError={() => setBroken(true)} />
        ) : (
          <div className="oot-ph">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
              <path d="M3 7l9-4 9 4v10l-9 4-9-4z" /><path d="M3 7l9 4 9-4M12 11v10" />
            </svg>
            <span>{data.name}</span>
          </div>
        )}
      </div>
      <div className="oot-card-body">
        <div className="oot-card-name">{data.name}</div>
        <div className="oot-card-foot">
          <div className="oot-price">${price}{hasDiscount && <span className="was">${was}</span>}</div>
          <button className="oot-add" title="View product" onClick={(e) => { e.stopPropagation(); open(); }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="20" r="1.5" /><circle cx="18" cy="20" r="1.5" />
              <path d="M2 3h2.2l2.3 12.4a2 2 0 0 0 2 1.6h8.7a2 2 0 0 0 2-1.6L21 7H5.5" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Item;
